import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useApi, useLoading } from '../../../hooks'

import Invoices from './Invoices'
import { sortToObject } from '../../../utils/sort'
import { ContainerProvider } from '../../containerContext'
import { FILTER_DATE_RANGE } from '../../../core/constants/app'

import { PAYMENT_STATUS } from '../../../core/constants/filter'

const queryOrigin = {
	query: {
		skip: 0,
		limit: 100,
		// Free text, kept outside filter so the mobile filter reset leaves it alone
		search: '',
		filter: {
			dateRange: FILTER_DATE_RANGE.ALLTIME,
			vendor: 'all',
			payment: PAYMENT_STATUS.ALL
		}
	},
	sorted: {
		sortBy: 'dateCreated',
		sortDirection: 'desc'
	},
}

const Index = () => {
	const [state, setState] = useState({ ...queryOrigin })
	const { invoiceService } = useApi()

	const { isLoading, isFetching, data = [] } = useQuery(['invoices', state.query, state.sorted], () => {
		const { filter, search, ...otherQuery } = state.query
		const params = {
			...otherQuery,
			sort: {...sortToObject(state.sorted)},
			filter: {
				// company: clientPortalUser.clientPortalCompany,
				payment: [filter.payment]
			}
		}

		const { startDate, endDate, vendor } = filter
		if (startDate && endDate) params.filter = { ...params.filter, startDate, endDate}
		if (vendor !== 'all') params.filter.company = vendor
		// The API switches to its Atlas search path when text is present
		if (search && search.trim()) params.text = search.trim()

		return invoiceService.getMany(params).then(res => res.invoices)
	}, {
		refetchOnWindowFocus: false
	})

	// Same cue as the admin portal: the MTRX spinner over a dimmed screen while
	// results (first page, filters, search) are being fetched.
	useLoading(isFetching)

	return (
		<ContainerProvider
			state={state}
			setState={setState}
			data={data || []}
			stateOrigin={queryOrigin}
			isLoading={isLoading}
		>
			<Invoices />
		</ContainerProvider>
	)
}

export default Index
